import gql from 'graphql-tag';

export const agentLogRowPartFragment = gql`
  fragment agentLogRowPartFragment on AgentLogRowPart {
    type
    text
    id
    name
    input
    toolCallID
    isError
    content
  }
`;
export default agentLogRowPartFragment;
